<template>
  <div class="search">
    <header>
      <form action="/">
        <van-search
          :placeholder="'搜索你要查找的内容'"
          @cancel="cancel"
          @search="search"
          clearable
          maxlength="32"
          show-action
          v-model="searchValue"
        ></van-search>
      </form>
      <!--      v-focus="isShow"-->
      <!--<span @click="cancel">取消</span>-->
    </header>
    <Scroller
      :is-refresh-data.sync="refresh"
      :is-loading-data.sync="loading"
      :is-finished-data.sync="finished"
      @on-refresh="onRefresh"
      @on-infinite="onInfinite"
      class="my_scroller"
      ref="my_scroller"
    >
      <div class="history_list" v-if="list && list.length">
        <community-detail-item
          v-for="(item, index) of list"
          class="listitem"
          :detailItem="item"
          :key="index"
          followBtnHide
          titleTopShow
          btnLineShow
          @detailItemHandle="detailItemHandle"
        ></community-detail-item>
      </div>
    </Scroller>
    <empty
      v-if="empty && list && !list.length"
      :path="'noSearch'"
      :content="'换个词试试吧！<br />暂未找到您要搜索的内容～'"
    ></empty>
  </div>
</template>

<script>
import { fenxiang, isWeixin } from '@/assets/common/js/config'
import communityDetailItem from '../common/communityDetailItem'
import Scroller from '../common/Scroller.vue'
import empty from '../emptypage/empty'
export default {
  name: 'beautitySaidSearchResult',
  data() {
    return {
      refresh: false,
      loading: false,
      finished: false,
      searchValue: '',
      historyList: [],
      list: [],
      pageno: 0,
      pagesize: 10,
      empty: false
    }
  },
  components: {
    communityDetailItem,
    Scroller,
    empty
  },
  beforeMount() {
    if (this.$route.query.searchval) {
      this.searchValue = decodeURIComponent(this.$route.query.searchval)
    }
    if (this.searchValue !== '') {
      this.noRepeat()
    }
  },
  mounted() {
    if (isWeixin()) fenxiang({ path: 'beautitysearchresult' })
  },
  methods: {
    getData: function() {
      var url =
        this.$ajax.searchVideo_URL +
        `?pageno=${this.pageno}&pagesize=${this.pagesize}&keywords=${this.searchValue}`
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          if (this.pageno === 1) {
            this.list = res.data.list.map((item) => {
              item.isbeautitysaid = 1
              return item
            })
            this.refresh = false
          } else {
            this.list = this.list.concat(
              res.data.list.map((item) => {
                item.isbeautitysaid = 1
                return item
              })
            )
          }
          this.loading = false
          if (res.data.list.length < this.pagesize) {
            this.finished = true
            if (!this.list.length) {
              this.empty = true
            } else {
              this.empty = false
            }
          } else {
            this.finished = false
          }
        }
      })
    },
    onRefresh() {
      this.refresh = true
      this.pageno = 1
      this.getData()
    },
    onInfinite() {
      this.loading = true
      this.finished = false
      this.pageno++
      this.getData()
    },
    cancel() {
      this.$app.argFunc(
        () => {
          this.$router.go(-1)
        },
        () => {
          wx.miniProgram.navigateBack()
        }
      )
    },
    search() {
      if (this.searchValue != '') {
        this.$clickburiedPoint({
          url: 'ckysdatacenter/searchword/save',
          data: {
            type: 'beautity',
            keyword: this.searchValue
          }
        })
        this.noRepeat()
        this.empty = false
        this.pageno = 0
        this.list = []
        this.onInfinite()
      } else {
        this.$toast('请正确输入查询内容')
      }
    },
    detailItemHandle(item, index) {
      this.list.splice(index, 1, item)
    },
    noRepeat: function() {
      if (
        localStorage.getItem('beautitysaid_historylist') !== null &&
        localStorage.getItem('beautitysaid_historylist') !== undefined &&
        localStorage.getItem('beautitysaid_historylist') !== ''
      ) {
        this.historyList = JSON.parse(localStorage.getItem('beautitysaid_historylist'))
        var historyArr = []
        var obj = {}
        this.historyList.unshift(this.searchValue)
        for (var i of this.historyList) {
          if (!obj[i]) {
            historyArr.push(i)
            obj[i] = 1
          }
        }
        if (historyArr.length > 20) {
          historyArr.splice(historyArr.length - 1, 1)
          localStorage.setItem('beautitysaid_historylist', JSON.stringify(historyArr))
        } else {
          localStorage.setItem('beautitysaid_historylist', JSON.stringify(historyArr))
        }
      } else {
        this.historyList.unshift(this.searchValue)
        localStorage.setItem('beautitysaid_historylist', JSON.stringify(this.historyList))
      }
    }
  }
}
</script>

<style scoped lang="scss">
header {
  background-color: #ffffff;
  padding-left: 0.11rem;
  position: relative;
  z-index: 1;
}
.history_list {
  height: calc(100vh - 0.54rem);
  padding: 0.12rem 0.11rem;
  .listitem {
    margin-bottom: 0.1rem;
    border-radius: 0.1rem;
  }
}
.history_item {
  position: relative;
  margin-bottom: 0.12rem;
  .clock_icon {
    vertical-align: middle;
  }
  span {
    color: #333333;
  }
}
.close {
  position: absolute;
  right: 0;
  top: 0.03rem;
}
</style>



// WEBPACK FOOTER //
// src/components/community-beautitysaid/searchResult.vue